module.exports = __webpack_public_path__ + "static/award4-8a55406fe2acc1b96e210ae74ad4a7ae.png";